export const PUESTOS_HIPICOS_STATUS_CLASSES = {
  pending: 'badge badge-warning p-1 rounded',
  refund: 'badge badge-secondary p-1 rounded',
  won: 'badge badge-success p-1 rounded',
  lost: 'badge badge-danger p-1 rounded',
  cancelled: 'badge badge-secondary p-1 rounded',
  proposal: 'badge badge-warning p-1 rounded',
  won_half: 'badge badge-primary p-1 rounded',
  lost_half: 'badge badge-warning p-1 rounded',
  tied: 'badge badge-info p-1 rounded',
  cut: 'badge badge-info p-1 rounded',
  returned: 'badge badge-secondary p-1 rounded',
  eliminated: 'badge badge-secondary p-1 rounded',
  withdrawn: 'badge badge-secondary p-1 rounded',
}

export const PUESTOS_HIPICOS_STATUS_LABELS = {
  pending: 'status.pending',
  won: 'status.won',
  lost: 'status.lost',
  refund: 'status.refund',
  cancelled: 'status.null_bet',
}

export const puestosHipicosStatusKey = (status) =>
  PUESTOS_HIPICOS_STATUS_LABELS[status] || `status.${status}`

export const puestosHipicosHorseLabel = (bet) => {
  if (!bet) return '-'
  const label = [bet.horseNumber, bet.horseName].filter(Boolean).join(' - ')
  return label || '-'
}

export const puestosHipicosAmount = (value) => {
  const parsed = Number(value)
  if (!Number.isFinite(parsed)) return '0.00'
  return parsed.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export const PUESTOS_HIPICOS_LIVE_ENDPOINTS = Object.freeze({
  racecoursesToday: '/puestos-hipicos/racecourses/today',
  amountInGame: '/puestos-hipicos/amount-in-game',
})

export const PUESTOS_HIPICOS_TYPE_QUERY = Object.freeze({
  general: 0,
  byRace: 1,
  byRacecourse: 2,
})

export const PUESTOS_HIPICOS_LIVE_REFRESH_MS = 30000

export const PUESTOS_HIPICOS_LIVE_TIMEOUT_MS = 25000

export const PUESTOS_HIPICOS_RACECOURSES_REFRESH_MS = 300000

export const PUESTOS_HIPICOS_LIVE_PERMISSION = 'see_puestoshipicos_live_panel'

const LIVE_ERRORS = {
  PROVIDER_INVALID_INTEGRATOR: { key: 'invalid_integrator', terminal: true },
  PROVIDER_GROUP_NOT_ASSIGNED: { key: 'no_group', terminal: true },
  API_URL_NOT_CONFIGURED: { key: 'not_configured', terminal: true },
  CREDENTIALS_NOT_CONFIGURED: { key: 'not_configured', terminal: true },
  INTEGRATOR_NOT_CONFIGURED: { key: 'not_configured', terminal: true },
  LIVE_ACCESS_DENIED: { key: 'not_configured', terminal: true },
  PRODUCT_NOT_FOUND: { key: 'not_enabled', terminal: true },
  CUSTOMER_NOT_FOUND: { key: 'not_enabled', terminal: true },
  CUSTOMER_PRODUCT_NOT_ASSOCIATED: { key: 'not_enabled', terminal: true },
  PROVIDER_UNAVAILABLE: { key: 'unavailable', terminal: false },
  GATEWAY_UNAVAILABLE: { key: 'unavailable', terminal: false },
  PROVIDER_TIMEOUT: { key: 'timeout', terminal: false },
  GATEWAY_TIMEOUT: { key: 'timeout', terminal: false },
}

const liveError = (key, terminal) => ({
  key: `puestos_hipicos.live.errors.${key}`,
  terminal,
})

export const puestosHipicosLiveError = (error) => {
  const response = error && error.response
  if (!response) {
    return liveError(error && error.code === 'ECONNABORTED' ? 'timeout' : 'unavailable', false)
  }

  const message = response.data && response.data.message
  const code = Array.isArray(message) ? message[0] : message
  if (LIVE_ERRORS[code]) return liveError(LIVE_ERRORS[code].key, LIVE_ERRORS[code].terminal)
  if (response.status === 400) return liveError('invalid_request', true)
  if (response.status === 403) return liveError('forbidden', true)
  return liveError('generic', false)
}

export const puestosHipicosShare = (amount, total) => {
  const value = Number(amount)
  const sum = Number(total)
  if (!Number.isFinite(value) || !Number.isFinite(sum) || sum <= 0) return '-'
  return `${((value / sum) * 100).toFixed(1)}%`
}
